import { apiBaseUrl, browserTransport, createApi } from '@/api/client';
import { SessionStore } from '@/api/session';
import { db as defaultDb, type TagnDB } from '@/data/db';
import { NotesRepository } from '@/data/notes';
import { SyncEngine } from '@/data/sync';
import type { Interceptor, Transport } from '@connectrpc/connect';
import type { Services } from './services';

/** Wires the production services. Transport and DB can be replaced in tests. */
export function createServices(opts: { db?: TagnDB; transport?: (i: Interceptor[]) => Transport; storage?: Storage } = {}): Services {
  const db = opts.db ?? defaultDb;
  const sessions = new SessionStore(opts.storage ?? localStorage);
  const api = createApi(sessions, opts.transport ?? browserTransport(apiBaseUrl(import.meta.env.VITE_API_URL, window.location.origin)));
  const repo = new NotesRepository(db);
  const sync = new SyncEngine(db, api.notes, { ownerId: () => sessions.get()?.user.id ?? '' });
  return { api, sessions, db, repo, sync };
}
